import { columnTypes, columnVisibility } from "@its-ui/planner-common/constants";

export const showCustomFieldsSectionHelper = (customFields) => customFields?.some(
    f => f.columnVisibility != columnVisibility.Nobody // Must be visible to someone
    && f.type !== columnTypes.Topic
    && f.type !== columnTypes.TopicThumbnail);
